import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './locales/en.json';
import it from './locales/it.json';
import enValidationMessages from 'vee-validate/dist/locale/en.json';
import itValidationMessages from 'vee-validate/dist/locale/it.json';

Vue.use(VueI18n);

// Ready translated locale messages
const messages = {
    en: {
        ...en,
        validation: enValidationMessages.messages,
    },
    it: {
        ...it,
        validation: itValidationMessages.messages,
    },
};

// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: 'it',
    fallbackLocale: 'it',
    messages,
});

export { i18n };
